import { render, staticRenderFns } from "./CustomFormGroup.vue?vue&type=template&id=a665d7dc&"
import script from "./CustomFormGroup.vue?vue&type=script&lang=js&"
export * from "./CustomFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./CustomFormGroup.vue?vue&type=style&index=0&id=a665d7dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports